
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import StepList from "@/components/scope/step-list.vue";
import { Table, InjectFunction } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";
import TextTips from "@common/src/components/scope/text-tips/index.vue";
import InventoryCheckPrint from "./components/inventory-check-print.vue";
import dayjs from "dayjs";
import { formDownload } from "@common/src/utils/tools";
import _ from "lodash-es";

const inventory = namespace("inventory");
const app = namespace("app");

@InjectFunction("dayjs", "addCurrencyUnit", "emptyToLine", "splitThousands", "permit", "permitApp")
@Component({
  components: {
    StepList,
    TextTips,
    InventoryCheckPrint
  }
})
@Table("loadListData")
export default class InventoryCheckView extends Vue {
  @inventory.Action queryInventoryCheckDetail;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @inventory.Action createInventoryCheck;
  @inventory.Action deleteInventoryCheck;
  @inventory.Action queryStocktakingParts;
  @inventory.Action queryStocktaking;
  @inventory.Action saveAddPartialStocktakingParts;
  @inventory.Action saveAllStocktaking;

  get breadData() {
    return [
      { name: t("v216_6.inventory-check"), path: "/inventory/inventory-check/list" },
      { name: t("v216_6.inventory-sheet") }
    ];
  }
  detailData: any = { partsParams: [] };
  dataLoading = false;
  created() {
    this.init();
  }
  handleMoreMenuClick(command) {
    if (command === "delete") {
      this.$confirm(t("v216_6.delete-current-inventory-sheet"), t("v210831.tips"), {
        confirmButtonText: t("v210831.determine"),
        cancelButtonText: t("base.cancel"),
        type: "warning"
      }).then(() => {
        this.deleteInventoryCheck({
          stocktakingCode: this.detailData.stocktakingCode
        }).then(() => {
          this.$message.success(t("v210831.delete-succeeded"));
          this.$router.push("/inventory/inventory-check/list");
        });
      });
    }
  }
  get orderId() {
    return this.$route.params.id;
  }
  init() {
    this.loadListData();
    this.getInventoryCheckDetail();
  }
  showPrint: boolean = false;
  handleShowPrintOrder() {
    this.showPrint = true;
  }
  handleFilterChange() {
    this.mix_pageNum = 1;
    this.loadListData();
  }
  showOnlyNoChecked = false;
  showOnlyCheckNoPass = false;
  diffAddSymbol(num) {
    num = Number(num);
    return num > 0 ? "+" + num : num;
  }
  allMuchNum = 0;
  allLessNum = 0;
  computedAllDiff() {
    this.allMuchNum = 0;
    this.allLessNum = 0;
    this.detailData.partsParams.forEach(row => {
      row.diffQty = Number((row.inventoryActualQty - row.inventoryQty).toFixed(2));
      if (row.diffQty > 0) {
        this.allMuchNum += row.diffQty;
      } else if (row.diffQty < 0) {
        this.allLessNum += row.diffQty;
      }
    });
    this.allMuchNum = Number(this.allMuchNum.toFixed(2));
    this.allLessNum = Number(this.allLessNum.toFixed(2));
  }
  async handleSubmitInventoryCheck() {
    await this.$confirm(t("v3_5_0.inventory-check-submit-tips"), t("v210831.tips"), {
      confirmButtonText: t("v210831.determine"),
      cancelButtonText: t("base.cancel"),
      type: "warning"
    });

    this.btnStartLoading();
    const saveApi =
      this.detailData.stocktakingType === "2" ? this.saveAllStocktaking : this.saveAddPartialStocktakingParts;
    saveApi({
      ...this.detailData,
      stocktakingStatus: "2"
    })
      .then(() => {
        this.$message.success(t("v216_6.inventory-sheet-submitted"));
        this.init();
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  handleExport() {
    formDownload(`${window.API_URL}/inventory/stocktaking/exportStocktakingParts`, {
      stocktakingCode: this.orderId,
      ...this.searchForm
    });
  }
  searchForm: any = {
    partsName: "",
    showOnlyProfitAndLoss: ""
  };
  checkPartsList: any = [];
  summaryData: any = {};
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryStocktakingParts({
      ...this.searchForm,
      stocktakingCode: this.orderId,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.checkPartsList = (data?.data?.list || []).map(item => {
        item.showInputProper = false;
        return item;
      });
      this.summaryData = _.pick(data.data, ["countStocktakingPartsDetail", "deficitQuantity", "surplusQuantity"]);
      return data;
    });
  }

  getInventoryCheckDetail() {
    this.queryStocktaking({
      stocktakingCode: this.orderId
    }).then(data => {
      data.data.stocktakingDate = dayjs(data.data.stocktakingDate).format("YYYYMMDD");
      this.detailData = data.data || {};
    });
  }
  get totalProfitNum() {
    return (Number(this.summaryData.deficitQuantity) + Number(this.summaryData.surplusQuantity)).toFixed(2);
  }
}
